import React from 'react';
import { MapPin, Briefcase, Clock } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { careers } from '../mockData';
import Newsletter from '../components/Newsletter';

const Careers = () => {
  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-black via-[#1a1a1a] to-black"></div>
        <div className="absolute inset-0 opacity-20">
          <div className="absolute bottom-20 left-1/2 w-96 h-96 bg-[#C9A55A]/20 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Join Our <span className="text-[#C9A55A]">Team</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Build your career with a team of exceptional consultants dedicated to excellence
          </p>
        </div>
      </section>

      {/* Why Join Section */}
      <section className="py-20 bg-gradient-to-b from-black to-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">Why Syndicate?</h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              Join a culture of innovation, collaboration, and professional growth
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card className="bg-white/5 border-white/10">
              <CardContent className="p-8 text-center">
                <div className="text-[#C9A55A] text-4xl font-bold mb-2">15+</div>
                <div className="text-white font-semibold mb-2">Years of Excellence</div>
                <p className="text-gray-400 text-sm">Established reputation in strategic consulting</p>
              </CardContent>
            </Card>
            <Card className="bg-white/5 border-white/10">
              <CardContent className="p-8 text-center">
                <div className="text-[#C9A55A] text-4xl font-bold mb-2">6</div>
                <div className="text-white font-semibold mb-2">Industries</div>
                <p className="text-gray-400 text-sm">Diverse portfolio of sectors and clients</p>
              </CardContent>
            </Card>
            <Card className="bg-white/5 border-white/10">
              <CardContent className="p-8 text-center">
                <div className="text-[#C9A55A] text-4xl font-bold mb-2">100+</div>
                <div className="text-white font-semibold mb-2">Projects</div>
                <p className="text-gray-400 text-sm">Successful government and private contracts</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Open Positions */}
      <section className="py-20 bg-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">Open Positions</h2>
            <p className="text-xl text-gray-400">Explore opportunities to grow with us</p>
          </div>

          <div className="max-w-4xl mx-auto space-y-6">
            {careers.map((job) => (
              <Card key={job.id} className="bg-white/5 border-white/10 hover:border-[#C9A55A]/50 transition-all duration-300">
                <CardContent className="p-8">
                  <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
                    <div className="mb-4 lg:mb-0">
                      <h3 className="text-2xl font-bold text-white mb-3">{job.title}</h3>
                      <p className="text-gray-400 mb-4">{job.description}</p>
                      <div className="flex flex-wrap gap-4 text-sm text-gray-500">
                        <div className="flex items-center space-x-2">
                          <MapPin size={16} />
                          <span>{job.location}</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <Briefcase size={16} />
                          <span>{job.type}</span>
                        </div>
                      </div>
                    </div>
                    <Button className="bg-[#C9A55A] text-black hover:bg-[#B8941F] font-semibold whitespace-nowrap">
                      Apply Now
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-gradient-to-b from-[#0a0a0a] to-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">Benefits & Perks</h2>
            <p className="text-xl text-gray-400">We invest in our people</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              "Competitive Compensation",
              "Health & Dental Benefits",
              "Professional Development",
              "Flexible Work Arrangements",
              "Performance Bonuses",
              "Retirement Planning"
            ].map((benefit, index) => (
              <div key={index} className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-[#C9A55A] rounded-full"></div>
                <span className="text-gray-300">{benefit}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Newsletter />
    </div>
  );
};

export default Careers;